import Contact from "components/Contact";
import Footer from "components/Footer";
import Navbar from "components/Navbar";
import React from "react";
import { useLocation } from "react-router-dom";

interface BlankLayoutProps {
  children: React.ReactNode;
}

const BlankLayout = (props: BlankLayoutProps) => {
  const { children } = props;
  const { pathname } = useLocation();

  return (
    <>
      <Navbar />
      {children}

      {pathname !== "/styleguide" && (
        <>
          <Contact />
          <Footer />
        </>
      )}
    </>
  );
};

export default BlankLayout;
